angular.module('omfm').controller('menuController', MenuControllerController);

MenuControllerController.$inject = ['$scope'];

function MenuControllerController($scope) {
	$scope.menuOpen = false;

	$scope.toggleMenu = function(){
		$scope.menuOpen = !$scope.menuOpen;
	}
}